import { useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { transactionsService } from '../services/transactionService'
import { useEffect } from 'react'

interface useBanksProps {
  allBanks?: boolean
}
export const useBanks = ({ allBanks }: useBanksProps) => {
  const params = { allBanks: allBanks ? 'true' : 'false' }

  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['banks', params],
    queryFn: async () => transactionsService.banks(params),
    select(data) {
      const banks = data.banks.map(({ label, value }) => ({
        label: `${value} - ${label}`,
        value,
      }))

      return { banks }
    },
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
  }
}
